module.exports = __webpack_public_path__ + "img/thumb_26.f4713b61.jpg";